<template>
    <v-container
        fluid
        class="px-4"
        v-if="pocket">

        <v-row>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.pocketId')"/>

                <div>
                    {{ pocket.id }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.activationDate')"/>

                <div>
                    {{ $util.getDDMMYYYYHHSSDateFormat(pocket.createdAt) }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.customerId')"/>

                <div>
                    {{ pocket.CustomerID }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.customerEmail')"/>

                <div>
                    {{ pocket.email }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.firstName')"/>

                <div>
                    {{ pocket.name}}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.lastName')"/>

                <div>
                    {{ pocket.lastname }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.nationality')"/>

                <div>
                    {{ pocket.nationality }}
                </div>
            </v-col>

            <hr class="full-width ma-4">

            <v-col cols="12">
                <span
                    class="subtitle-2 font-weight-bold mr-2"
                    v-html="$t('andamandaPay.pocketDetails.currentBalance')"/>
                <icon
                    value="custom_coin"
                    size="18px"/>

                <br/>

                <v-row>
                    <v-col
                        cols="5">
                        <v-text-field
                            outlined
                            readonly
                            hide-details
                            height="40px"
                            :value="balance"/>
                    </v-col>
                </v-row>
            </v-col>

            <v-col
                cols="12">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.pocketDetails.transactionHeader')"/>
            </v-col>

            <v-col
                class="pt-0"
                cols="12">
                <transaction-table
                    disable-sort
                    :items="pocket.transactions"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else></div>
</template>

<script>
import TransactionTable from '@/components/tables/TransactionTable'

export default {
    name: 'PocketDetailsView',

    components: {
        TransactionTable
    },

    props: {
        pocket: {
            type: Object,
            default: () => null
        }
    },

    computed: {
        balance () {
            return this.pocket.balance?.[0]?.TotalBalance ?? 0
        }
    }
}
</script>

<style lang="scss" scoped></style>
